import { TranslateLoader, TranslationObject } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import idJson from '../../../../public/i18n/id.json';
import enJson from '../../../../public/i18n/en.json';

export class ServerTranslateLoader extends TranslateLoader {
  override getTranslation(lang: string): Observable<TranslationObject> {
    return new Observable((observer) => {
      if (lang === 'id') {
        observer.next(idJson);
      } else {
        observer.next(enJson);
      }
    });
  }
}
